import * as React from "react";
const SvgDrive = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={28} viewBox="0 0 32 28" {...props}><path d="M16.087 10.34 10.963 1.5 0 20.656 5.037 29.5z" data-name="Trazado 553" style={{
    fill: "#4caf50"
  }} transform="translate(0 -1.5)" /><path d="M8.222 1.5 19.3 20.656h9.959L18.3 1.5z" data-name="Trazado 554" style={{
    fill: "#ffc107"
  }} transform="translate(2.741 -1.5)" /><path d="m8.878 15.867-5.1 8.844H25.7l5.037-8.844z" data-name="Trazado 555" style={{
    fill: "#2196f3"
  }} transform="translate(1.259 3.289)" /></svg>;
export { SvgDrive as ReactComponent };